import { CS } from "../../../../utils/modules/reselect";
import { pageSelectors } from "../../../../pages/_core/pagesSelectors";


export const popupSelector = {
  type: CS(pageSelectors.popup, popup => popup.type),
  props: CS(pageSelectors.popup, popup => popup.props),
  inFocus: CS(pageSelectors.popup, popup => popup.inFocus),
};
